// Nav badge for Sales > Dispatches: number of OPEN + DRAFT slips. One cheap count call (GET /sales-dispatches/count, distinct slips, memoised on the
// api); shared by LeftMenu + ModuleBar. Refreshes on the api's own write bus (any dispatch / delivery write) and every 60 s while the tab is visible. Fail-soft: null hides it.
import { useState, useEffect } from 'react';
import { onDataMutation } from '../services/api';
import { shellRead, shellPoll } from './shellRead';

let _count = null;
const _subs = new Set();
let _timer = null;
let _unsub = null;

const apply = (r, err) => { _count = !err && r && r.count != null ? Number(r.count) : null; _subs.forEach(fn => fn(_count)); };
// Round 1 (C1): now + every 60 s, skipped while the tab is hidden, never overlapping. No fresh flag: the api memo is 10 s, shorter than the poll,
// so a poll already reads fresh; writes still ask fresh=1 below. Round 4e: through shellRead / the shell's ONE poll timer (one request for all).
export function useDispatchCount(enabled = true) {
  const [n, setN] = useState(_count);
  useEffect(() => {
    if (!enabled) return undefined;
    _subs.add(setN); setN(_count);
    if (_subs.size === 1) {
      _timer = shellPoll('dispatches', apply);
      _unsub = onDataMutation(ep => { if (/dispatch|delivery-events/.test(String(ep))) shellRead('dispatches', { fresh: true }).then(r => apply(r), e => apply(null, e)); });
    }
    return () => { _subs.delete(setN); if (!_subs.size) { _timer(); if (_unsub) _unsub(); } };
  }, [enabled]);
  return n;
}
export const badgeText = n => (n > 99 ? '99+' : String(n));
